<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Sync Archive Event (JWPlayer to Tone Database)</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <router-link to="/" class="btn btn-primary" role="button">
            back
          </router-link>
        </div>
      </div>
      <br/>
      <form @submit.prevent="update">
        <div class="row justify-content-md-center">
          <div class="col-12" v-if="archEvents.length">
            <fg-select
              v-model="syncEventId"
              label="Select Event to Sync"
              :list="archEvents"
              selectedKey="eventId"
              showLabel="title"
            >
            </fg-select>
          </div>
          <div class="col-6 text-center" v-if="syncEventId">
            <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
              Sync Event Videos
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'EditSyncEvent',
    created (){
      this.fetchArchiveEvents();
      // this.$store.dispatch('GETSELECTEDPLAYLIST', this.$route.params.id)
      // this.fetchCorporations();
      // console.log('selected playlist', this.selectedPlaylist)
    },
    data () {
      return {
        syncEventId: 0,
        videoCount: 0,
        limitExceed: false,
        archEvents: [],
//            playlist: null,
        status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        rules: {
          syncEventId: {required: true}
        }
      }
    },
    watch: {
    },
    methods: {
      fetchArchiveEvents () {
        this.$store.dispatch('FETCH_ALL_ARCHIEVE_EVENTS')
          .then((res) => {
            console.log('res', res)
            this.archEvents = res;
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
      update () {
        this.$validator.validateAll().then((result) => {
          if(result){
            let update = () =>{
              this.$store.dispatch('SYNC_ARCHIVE_EVENT', this.syncEventId)
                .then((res) => {
                  console.log("UPDATE Archive Playlist : ", res);
                  this.showPopup('Success!', 'Archive Has been synced successfully', 'success')
                })
                .catch(err => {
                  this.showPopup('Error!', 'An error occurred, request could not be completed', 'error')
                  console.log("UPDATE_CORPORATION API error : ", err);
                })
            };
            update();
          }
        })
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },
    computed: {
      ...mapGetters([ 'corporations', 'selectedPlaylist']),
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      playlist(){
        return this.selectedPlaylist
      }
    }
  }
</script>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ArchiveSync.vue